import React, { useState } from 'react';
import Button from '../Button/Button';
const ItemPlace = (props) => {
    const [classColor, setClassColor] = useState('');
    const [buttonName, setButtonName] = useState('?');
    const [buttonColor, setButtonColor] = useState('');
    const handleAnswer = (() => {
        if (props.id < 4) {
            setClassColor(' well');
            setButtonName(props.tasksGame.Yes)
            setButtonColor(' Yes');
            props.onClick('answer', props.place, props.id);
        }
        else {
            setClassColor(' wrong');
            setButtonName(props.tasksGame.No);
            setButtonColor(' No');
            props.onClick('wrong',props.place, props.id);
        }
    });
    return <div>
        <div className={props.className + classColor}> {props.value} </div>
        <Button className={props.classButton + buttonColor} onClick={() => handleAnswer()} value={buttonName} />
    </div>
}

export default ItemPlace;